import React from 'react';
import Slider from 'react-slick';
import Fullscreen from 'react-fullscreen-crossbrowser';
import { isMobileSafari } from 'react-device-detect';
import FullscreenIOS from 'mobile-safari-fullscreen';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import ReactPlayer from 'react-player/lib/players/YouTube';
import shortid from 'shortid';
import Slide from './BannerSlide';
import BannerManager from '../../managers/BannerManager';
import styles from '../../../node_modules/mobile-safari-fullscreen/dist/index.module.css';

import {
  LeftArrowIcon,
  RightArrowIcon,
  ContractIcon,
  ExpandIcon,
  InfoIcon,
  DownloadAppleIcon,
  CloseIcon,
  AppleIcon,
} from '../../managers/IconManager';

import ProjectSlider from './ProjectSlider';
import IOSImageSlider from './IOSImageSlider';

class BannerSlider extends ProjectSlider {
  constructor(props) {
    super(props);
    this.handleAutoplay = this.handleAutoplay.bind(this);
    this.onStart = this.onStart.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.state = {
      ...this.state,
      showInfo: true,
      initial: true,
      isFull: false,
      playVideo: false,
      autoplay: false,
      videoStarted: false,
      nav1: null,
      nav2: null,
      nav3: null,
    };

    const { banner_id: bannerID } = this.props;
    if (bannerID) {
      const banners = new BannerManager(bannerID);
      this.projects = banners.getBannerImageManifest();
    }
    this.customClasses.dot = { normal: 'project_slider__dot--round', active: 'project_slider__dot--round--active' };
    this.responsive = [
      {
        breakpoint: 1,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ];
    this.settings = {
      ...this.settings,
      speed: 1500,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      onInit: () => {
        this.setState({
          autoplay: true,
        });
      },
      onReInit: () => {
        const breakpoint = 1;

        if (this.slider && this.state.breakpoint !== breakpoint) {
          this.setState({
            autoplay: true,
            initial: false,
            breakpoint,
            pageCount: this.getPageCount(breakpoint),
            slidesToShow: this.getSlidesToShow(breakpoint),
          });
        }
      },
      responsive: this.responsive,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider,
      nav2: this.slider2,
      nav3: this.slider3,
    });
    if (isMobileSafari) {
      window.addEventListener('scroll', this.handleAutoplay);
    }
  }

  handleAutoplay() {
    const { autoplay } = this.state;
    if (autoplay === true && window.pageYOffset > 0) {
      this.setState({
        autoplay: false,
      });
      window.removeEventListener('scroll', this.handleAutoplay);
    }
  }

  goFull = () => {
    this.setState({ isFull: true, autoplay: false });
  };

  getLeftDescription() {
    const { currentPage } = this.state;
    const index = currentPage || 0;
    const project = this.projects[index];

    return (
      <div className="banner_slider__left_description">
        {project
          && (project.title && (
            <div className="font-title-semi_bold  banner_slider__left_description__title">
              {project.title}
            </div>
          ))}
        {project && (
          <div className="font-paragraph banner_slider__left_description__subtitle">
            {project.subtitle ? project.subtitle : ''}
          </div>
        )}
      </div>
    );
  }

  static getLocalButton(button) {
    return (
      <Link
        key={`link-${shortid.generate()}`}
        className="banner_slider__buttons__more_info_button"
        to={`/info/${button.link}`}
      >
        <div className="font-title-medium banner_slider__buttons__more_info_button__text">

          More Info
        </div>
        {InfoIcon('banner_slider__buttons__more_info_button__icon')}
      </Link>
    );
  }

  static getExternalButton(button) {
    return (
      <a
        key={`a-${shortid.generate()}`}
        className="banner_slider__buttons__download_apple_button"
        href={button.link}
      >
        {DownloadAppleIcon(
          'banner_slider__buttons__download_apple_button__icon',
        )}
        {AppleIcon(
          'banner_slider__buttons__download_apple_button__icon--small',
        )}
      </a>
    );
  }

  getCurrentProject() {
    const { currentPage } = this.state;
    const index = currentPage || 0;
    const project = this.projects[index];
    return project;
  }

  configureButtons() {
    const { showInfo, isFull } = this.state;
    const project = this.getCurrentProject();
    const { buttons } = project;
    return (
      <div className="banner_slider__buttons">
        {buttons.map((btn) => {
          const { button } = btn;
          if (button.type === 'local' && showInfo) {
            return this.constructor.getLocalButton(button);
          } if (button.type === 'external') {
            return this.constructor.getExternalButton(button);
          }
          // console.log('Error: Carousel Button Type: ' + button.type);
          return <div key={`div-${shortid.generate()}`} />;
        })}
        <button
          type="button"
          className="banner_slider__fullscreen_button "
          onClick={() => {
            this.setState(prevState => ({ isFull: !prevState.isFull }));
          }}
        >
          {isFull
            ? ContractIcon('project_slider__icon')
            : ExpandIcon('project_slider__icon')}
        </button>
      </div>
    );
  }

  getVideo() {
    const project = this.getCurrentProject();
    return `https://www.youtube.com/watch?v=${project.embedUrl}`;
  }

  isVideo() {
    const project = this.getCurrentProject();
    return project.embedUrl;
  }

  showVideo() {
    this.setState({
      playVideo: true,
      autoplay: false,
      videoStarted: false,
    });
  }

  onStart() {
    // Used to show close button after video starts playing
    this.setState({
      videoStarted: true,
    });
  }

  onPlay() {
    // Used to show close button after video starts playing
    this.setState({
      videoStarted: true,
    });
  }

  onEnded() {
    // Used to show close button after video starts playing
    console.log(`video onEnded : ${this.state.videoStarted}`);
    this.setState({
      videoStarted: false,
      playVideo: false,
    });
  }

  getVideoPlayer() {
    const { playVideo, isFull } = this.state;
    return (
      <div>
        <div
          className={
            !playVideo ? ' ' : ' banner_slider__video-wrapper--fix'
          }
        >
          <div
            className={
              !playVideo
                ? 'banner_slider--hide '
                : ` banner_slider--aspect ${
                  isFull
                    ? ' banner_slider--aspect--fullscreen '
                    : ''}`
            }
          >
            <div className="banner_slider__video-wrapper ">
              <ReactPlayer
                className="react-player"
                onStart={this.onStart}
                onEnded={this.onEnded}
                onPlay={this.onPlay}
                url={this.getVideo()}
                height="100%"
                width="100%"
                config={{
                  youtube: {
                    playerVars: {
                      autoplay: '0',
                      enablejsapi: '1',
                      modestbranding: '0',
                      rel: '0',
                      showinfo: '0',

                      // https://developers.google.com/youtube/player_parameters
                    },
                  },
                }}
                controls
                playing={playVideo}
              />
            </div>
          </div>
          {!isFull ? this.getVideoCloseBtn() : ''}
        </div>
        {isFull ? this.getVideoCloseBtn() : ''}
      </div>
    );
  }

  gotoSlideIndex(index) {
    const { playVideo } = this.state;
    if (playVideo) {
      this.setState({
        playVideo: false,
        videoStarted: false,
        autoplay: false,
      });
    } else {
      this.slider.slickGoTo(index);
    }
  }

  getVideoCloseBtn() {
    const { isFull, playVideo, videoStarted } = this.state;
    return (
      <button
        type="button"
        className={
          `banner_slider__arrow banner_slider__close--top_right ${
            isFull
              ? ' banner_slider__close--top_right--full '
              : ' '
          }${playVideo
            ? ' banner_slider__close--top_right--play '
            : ' '
          }  project_slider__button banner_slider__close ${
            !videoStarted
              ? ' banner_slider--invisible'
              : ' banner_slider--visible'}`
        }
        onClick={() => this.setState({
          playVideo: false,
          videoStarted: false,
          autoplay: false,
        })
        }
      >
        {CloseIcon(
          `project_slider__icon project_slider__icon--big ${
            !videoStarted
              ? ' banner_slider--invisible'
              : ' banner_slider--visible'}`,
        )}
      </button>
    );
  }

  getContentSlider(setSlider) {
    const { playVideo, nav2, autoplay } = this.state;
    return (
      <div>
        <div className="banner_slider__container--bg " />
        <div
          className={
            playVideo
              ? ' banner_slider--hide '
              : 'banner_slider--absolute banner_slider--100hw'
          }
        >
          <Slider
            asNavFor={isMobileSafari ? null : nav2}
            ref={(c) => {
              if (setSlider) {
                this.slider = c;
              } else {
                this.slider3 = c;
              }
            }}
            {...this.settings}
            autoplay={autoplay}
          >
            {this.projects.map(project => (
              <Slide
                key={`slide-${shortid.generate()}`}
                project={project}
                slider={this}
              />
            ))}
          </Slider>
        </div>
        <div className={playVideo ? ' banner_slider--hide ' : ''}>
          <button
            type="button"
            className="banner_slider__arrow project_slider__button project_slider__button--big"
            onClick={() => {
              this.previous();
              this.setState({
                autoplay: false,
                videoStarted: false,
                playVideo: false,
              });
            }}
          >
            {LeftArrowIcon('project_slider__icon project_slider__icon--big ')}
          </button>
          <button
            type="button"
            className="banner_slider__arrow banner_slider__arrow--right project_slider__button project_slider__button--big"
            onClick={() => {
              this.next();
              this.setState({
                autoplay: false,
                videoStarted: false,
                playVideo: false,
              });
            }}
          >
            {RightArrowIcon('project_slider__icon project_slider__icon--big ')}
          </button>
        </div>
      </div>
    );
  }

  getContent(setSlider = true) {
    const { pageCount, playVideo, isFull } = this.state;
    return (
      <div>
        <div
          className={
            playVideo
              ? ' banner_slider--hide '
              : 'banner_slider__container '
          }
        >
          {this.getContentSlider(setSlider)}

          <div className={playVideo ? ' banner_slider--hide ' : ''}>
            <div className="banner_slider__overlay">
              <div
                className={
                  `banner_slider__bg ${
                    isFull ? ' banner_slider__bg--transparent' : ''}`
                }
              >
                <div className="banner_slider__dots">
                  {this.createDots(pageCount)}
                </div>
                {!isFull && this.configureButtons()}
              </div>
            </div>
            <div>{!isFull && this.getLeftDescription()}</div>
          </div>
        </div>

        {this.closeFullScreen()}
        {this.getVideoPlayer()}
      </div>
    );
  }

  closeFullScreen() {
    const { isFull, playVideo } = this.state;
    return (
      <div>
        {isFull && !playVideo && (
          <button
            type="button"
            className="banner_slider__arrow banner_slider__close--top_right  project_slider__button banner_slider__close "
            onClick={() => {
              this.setState(prevState => ({ isFull: !prevState.isFull }));
            }}
          >
            {CloseIcon('project_slider__icon project_slider__icon--big')}
          </button>
        )}
      </div>
    );
  }

  render() {
    const { isFull } = this.state;
    return (
      <div>
        {!isMobileSafari ? (
          <Fullscreen
            enabled={isFull}
            onChange={isFuller => this.setState({ isFull: isFuller })}
          >
            <div
              className={
                !isFull
                  ? 'full-screenable-node banner_slider'
                  : 'full-screenable-node banner_slider banner_slider__fullscreen'
              }
            >
              {this.getContent()}
            </div>
          </Fullscreen>
        ) : (
          <div>
            <div className={isFull && 'banner_slider--hide'}>
              {this.getContent()}
            </div>
            <FullscreenIOS classNames={styles} isOpen={isFull}>
              <Modal
                className="banner_slider__modal--fullscreen banner_slider__modal--bg_color"
                isOpen={isFull}
              >
                <div className="banner_slider__fullscreen">
                  <IOSImageSlider
                    projects={this.projects}
                    closeFull={() => {
                      this.setState(prevState => ({ isFull: !prevState.isFull }));
                    }
                  }
                    slideIndex={this.currentSlide}
                  />
                </div>
              </Modal>
            </FullscreenIOS>
          </div>
        )}
      </div>
    );
  }
}

export default BannerSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/BannerSlider.js